//
//
//
//
//
//
//
//
//
export default {
  inject: ["main"]
};